import { CustomerIoPayloadType } from './customerio.types';
import { PostHogEventPayloadType, PostHogExceptionPayloadType } from './posthog.types';

export enum PublishThirdPartyService {
  CUSTOMERIO = 'customerio',
  POSTHOG = 'posthog',
  /** Error tracking. Same topic and consumer as POSTHOG, different payload. */
  POSTHOG_EXCEPTION = 'posthog_exception'
}

export type PublishThirdPartyServicePayloadType = {
  service: PublishThirdPartyService;
  clientIp?: string;
  environment?: string; // development, production
  userAgent?: string;
  payload: CustomerIoPayloadType | PostHogEventPayloadType | PostHogExceptionPayloadType;
};
